import React from 'react';
import { Chip } from '@mui/material';
import { SUPPORT_TYPE_LABELS } from '../../utils/ticketConstants';

/**
 * Reusable support type chip component for tickets
 */
const SupportTypeChip = ({ type, size = 'small' }) => {
  const label = SUPPORT_TYPE_LABELS[type] || type || 'Other';

  return <Chip label={label} size={size} variant="outlined" />;
};

export default SupportTypeChip;
